import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import GuestList from '../GuestList/GuestList';
import Toolbar from '../Toolbar/Toolbar';
import ViewSelector from '../ViewSelector/ViewSelector';
import ActionsBar from '../ActionsBar/ActionsBar';
import DragLayer from '../DragLayer/DragLayer';

const ChartView = ({
  peopleCount,
  setView,
  tableCount,
  view,
}) => {
  const [viewGuestList, setViewGuestList] = useState(true);

  const ViewGuestListButton = () => (
    <button
      className="sc__guestlist-switch"
      onClick={() => setViewGuestList(!viewGuestList)}
    >
      {viewGuestList ? '\u003c\u003c Hide' : '\u003e\u003e Show Guest List'}
    </button>
  );

  return (
    <DndProvider backend={HTML5Backend}>
      <div className={`sc__container sc__container__chart ${!viewGuestList ? 'no-sidebar' : ''}`}>
        <aside className="sc__sidebar">
          {viewGuestList && (
            <GuestList>
              <ViewGuestListButton />
            </GuestList>
          )}
        </aside>
        <section className="sc__canvas">
          <Toolbar>
            {!viewGuestList && <ViewGuestListButton />}
            <ViewSelector
              view={view}
              setView={setView}
            />
            <ActionsBar />
          </Toolbar>
          {tableCount === 0 && <div className="sc__empty-doodle">Add some tables to get started</div>}
          <div className="sc__tables-container" />
        </section>
        <DragLayer numSelectedGuests={peopleCount} />
      </div>
    </DndProvider>
  );
};

ChartView.propTypes = {
  peopleCount: PropTypes.number,
  setView: PropTypes.func,
  tableCount: PropTypes.number,
  view: PropTypes.string,
};

export default ChartView;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartView/ChartView.jsx